import ModalTitle from "./ModalTitle.jsx";

export function modalTitle(icon, title, smallTitle) {
  return <ModalTitle icon={icon} smallTitle={smallTitle} title={title} />;
}
